export const FILES_LENGTH = 4;
